import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Stage from '../components/Stage';
import TourDatesCards from '../components/TourDates';


const TourDates = () => {
    return (
        <div>
            <Navbar />
            <center><Stage heading='BORN PINK WORLD TOUR [ENCORE]' text='NEXT STOP: LONDON, GB. JULY 2nd, 2023.' /></center>
            <TourDatesCards />
            <Footer />
        </div>
    )
}

export default TourDates;